import { createApiRef } from '@backstage/core-plugin-api';

import {
  CreateGroupMemberRequest,
  CreateGroupRequest,
  CreateUserMetadataRequest,
  Group,
  GroupMember,
  TeamsChannel,
  UpdateGroupMemberRequest,
  UpdateGroupRequest,
  UpdateUserMetadataRequest,
  UserMetadata,
} from '@internal/backstage-plugin-org-manager-common';

export const orgManagerApiRef = createApiRef<OrgManagerApi>({
  id: 'plugin.org-manager.service',
});

export interface OrgManagerApi {
  getTeamsChannels(): Promise<TeamsChannel[]>;
  getGroups(): Promise<Group[]>;
  getGroup(id: string): Promise<Group>;
  createGroup(request: CreateGroupRequest): Promise<Group>;
  updateGroup(id: string, request: UpdateGroupRequest): Promise<Group>;
  deleteGroup(id: string): Promise<void>;
  getGroupMembers(groupId: string): Promise<GroupMember[]>;
  getGroupMember(groupId: string, userEntityRef: string): Promise<GroupMember>;
  createGroupMember(
    groupId: string,
    request: CreateGroupMemberRequest,
  ): Promise<GroupMember>;
  updateGroupMember(
    groupId: string,
    userEntityRef: string,
    request: UpdateGroupMemberRequest,
  ): Promise<GroupMember>;
  deleteGroupMember(groupId: string, userEntityRef: string): Promise<void>;
  getAllUserMetadata(): Promise<UserMetadata[]>;
  getUserMetadata(userEntityRef: string): Promise<UserMetadata>;
  createUserMetadata(
    userEntityRef: string,
    request: CreateUserMetadataRequest,
  ): Promise<UserMetadata>;
  updateUserMetadata(
    userEntityRef: string,
    request: UpdateUserMetadataRequest,
  ): Promise<UserMetadata>;
  deleteUserMetadata(userEntityRef: string): Promise<void>;
}
